import axios from "axios";
import { BASE_URL } from "../config";

// Set your base API URL here
const API_BASE_URL = BASE_URL; // Use the base URL from config

// Function to handle API calls
const apiRequest = async (method, endpoint, data = null, params = null) => {
  try {
    const response = await axios({
      method,
      url: `${API_BASE_URL}/${endpoint}`,
      data,
      params,
    });
    return response.data; // Return only the data
  } catch (error) {
    console.error(`API ${method} request failed:`, error);
    throw error;
  }
};

// GET request
export const getData = async (endpoint, params = {}) => {
  return apiRequest("get", endpoint, null, params);
};

// POST request
export const postData = async (endpoint, data) => {
  return apiRequest("post", endpoint, data);
};

// PUT request
export const putData = async (endpoint, data) => {
  return apiRequest("put", endpoint, data);
};

// DELETE request
export const deleteData = async (endpoint) => {
  return apiRequest("delete", endpoint);
};

// Lock/Unlock API functions
export const lockTask = async (taskData) => {
  try {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    const response = await axios.post(`${process.env.REACT_APP_BASE_URL}api/tasks/lock`, taskData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Lock task API failed:', error);
    throw error;
  }
};

export const unlockTask = async (taskData) => {
  try {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    const response = await axios.post(`${process.env.REACT_APP_BASE_URL}api/tasks/unlock`, taskData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Unlock task API failed:', error);
    throw error;
  }
};

export const getAllLockStatus = async (partRef) => {
  try {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}api/tasks/${partRef}/all-lock-status`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Get all lock status API failed:', error);
    throw error;
  }
};

export const getRevisionLockStatus = async (revisionId) => {
  try {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}api/tasks/revision_${revisionId}/lock-status`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Get revision lock status API failed:', error);
    throw error;
  }
};

export const pingTask = async (taskData) => {
  try {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    const response = await axios.post(`${process.env.REACT_APP_BASE_URL}api/tasks/ping`, taskData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Ping task API failed:', error);
    throw error;
  }
};
